export default {
  getDisplayName(WrappedComponent, prefix) {
    return `${prefix}${
      WrappedComponent.displayName || WrappedComponent.name || 'Component'
    }`;
  }
};
